import React, { Component } from 'react'
import Header from '../Header'
import './XXVw.css'

class XXVw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXXVw">
                    <p className="textXXVw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XXVw